export const LOGS_RECEIVE = 'LOGS_RECEIVE';
export const LOGS_CLEAR = 'LOGS_CLEAR';
